import { configureStore } from "@reduxjs/toolkit";
import { rootReducer } from "./RootReducer";
import { initialStoreState } from "./store.state";
import { thunk } from "redux-thunk";
// ...

// export const store = configureStore({
//   reducer: rootReducer,
//   middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk),
//   // initialStoreState,
// });

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: true, // already true by default
      serializableCheck: false,
    }),
  preloadedState: initialStoreState, // use this instead of commenting out
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
